import { createSelector } from "@reduxjs/toolkit";
import useViewsSelector from "views/stores/useViewsSelector";
import { selectParameterBindings } from "views/logic/slices/searchExecutionSelectors";
import { selectParameters } from "views/logic/slices/viewSelectors";
const selectParametersAndBindings = createSelector(
  selectParameterBindings,
  selectParameters,
  (parameterBindings, parameters) => ({ parameterBindings, parameters })
);
const useParameters = () => useViewsSelector(selectParametersAndBindings);
export default useParameters;
